// Operations area: service queue, flight desk, calendar, departures (velín).
export const ops = {
  shared: {
    noneOption: "— none —",
  },
  countdown: {
    overdue: "{{days}}d overdue",
    today: "today",
    inDays: "{{days}}d",
  },
  flightDeadlines: {
    deposit: "Deposit",
    foc: "FOC release",
    ticketing: "Ticketing",
  },
  serviceQueue: {
    title: "Service queue",
    subtitle: "Supplier bookings across all orders — work your queue by deadline",
    viewMine: "Mine",
    viewUnassigned: "Unassigned",
    viewAll: "All",
    unassignedUrgent_one: "{{count}} unassigned with a deadline ≤ {{days}}d",
    unassignedUrgent_few: "{{count}} unassigned with a deadline ≤ {{days}}d",
    unassignedUrgent_other: "{{count}} unassigned with a deadline ≤ {{days}}d",
    searchPlaceholder: "Search by service name…",
    facetKind: "Kind",
    facetDestination: "Destination",
    facetStatus: "Status",
    facetSpecialist: "Specialist",
    noDestination: "No destination",
    unassigned: "Unassigned",
    emptyQueue: "Queue is clear",
    colService: "Service",
    colOrder: "Order",
    colCost: "Cost",
    colDeadlines: "Deadlines",
    colStatus: "Status",
    colSpecialist: "Specialist",
    onDemand: "on demand",
    onDemandTitle: "On demand — our own / always-available; no supplier confirmation needed",
    confirmBy: "confirm {{date}}",
    payBy: "pay {{date}}",
    overdueDays: "overdue {{days}}d",
    dueToday: "due today",
    dueInDays: "due in {{days}}d",
    you: "You",
    since: "since {{date}}",
    release: "Release",
    takeOverFrom: "Take over from {{name}}",
    confirmTakeOver: "Confirm take-over",
    claimedBy: "Claimed by {{name}} — take over?",
    takeOver: "Take over",
    claim: "Claim",
  },
  flightDesk: {
    title: "Flight desk",
    subtitle:
      "Group-seat blocks per departure — drawdown, the three deadlines (deposit · FOC · ticketing) and the money at risk on unsold seats.",
    flightQueue: "Flight queue",
    newAllotment: "New allotment",
    atRiskPrefix: "At risk this week:",
    atRiskSuffix_one:
      "on unsold seats across {{count}} block with a FOC deadline in the next 7 days.",
    atRiskSuffix_few:
      "on unsold seats across {{count}} blocks with a FOC deadline in the next 7 days.",
    atRiskSuffix_other:
      "on unsold seats across {{count}} blocks with a FOC deadline in the next 7 days.",
    empty: "No flight allotments yet.",
    createFirst: "Create the first block",
    colDeparture: "Departure",
    colAirlineRoute: "Airline / route",
    colSold: "Sold",
    colNextDeadline: "Next deadline",
    colAction: "Action",
    colStatus: "Status",
    colOwner: "Owner",
  },
  allotmentEdit: {
    newTitle: "New flight allotment",
    editTitle: "Edit flight allotment",
    airline: "Airline *",
    routeLabel: "Route / label *",
    blockPnr: "Block PNR",
    departure: "Departure",
    seatsTotal: "Seats in block",
    pricePerSeat: "Group price / seat",
    depositAmount: "Deposit amount",
    depositDeadline: "Deposit deadline",
    focCancellation: "FOC cancellation",
    ticketingDeadline: "Ticketing deadline",
    owner: "Owner (flight specialist)",
    unassignedOption: "— unassigned —",
  },
  monitoredFlights: {
    title: "Monitored flights",
    subtitle:
      "Live delay/cancellation watch per departure — works with or without an allotment. Checked automatically (daily, and hourly on the departure day); a task is raised on a cancellation or a 60-min delay.",
    direction: {
      outbound: "Outbound",
      return: "Return",
      other: "Other",
    },
    flightNoPlaceholder: "Flight no.",
    departureOptional: "— departure (optional) —",
    watch: "Watch",
    empty: "No flights being watched yet.",
    colFlight: "Flight",
    colDeparture: "Departure",
    colStatus: "Status",
    colDelay: "Delay",
    colChecked: "Checked",
    onTime: "on time",
    notChecked: "not checked",
    checkNow: "Check now",
    stopWatching: "Stop watching",
  },
  calendar: {
    title: "Calendar",
    subtitle: "Deadlines & tasks across orders and services",
    onlyMine: "Only mine",
    scan: "Scan",
    scanTitle: "Run deadline scan now",
    weekdays: {
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
    },
    nothingScheduled: "Nothing scheduled",
    noDueDate: "No due date",
    reopen: "Reopen",
    markDone: "Mark done",
  },
  departures: {
    title: "Departures",
    subtitle: "Upcoming group departures — manifest, rooming, shared services & break-even",
    empty: "No upcoming departures",
    colTrip: "Trip",
    colDates: "Dates",
    colGuide: "Guide",
    colBooked: "Booked",
    colStatus: "Status",
    waitlistShort: "+{{count}} wl",
    ordersCount_one: "({{count}} order)",
    ordersCount_few: "({{count}} orders)",
    ordersCount_other: "({{count}} orders)",
    occupancyTitle: "Derived from booked vs capacity",
    openVelin: "Open departure velín",
  },
  departureDetail: {
    fallbackTitle: "Departure",
    paxAcrossOrders_one: "{{pax}} pax across {{count}} order",
    paxAcrossOrders_few: "{{pax}} pax across {{count}} orders",
    paxAcrossOrders_other: "{{pax}} pax across {{count}} orders",
    manifestTitle: "Pax manifest",
    revealPassports: "Reveal passports",
    hidePassports: "Hide passports",
    manifestEmpty: "No participants yet — they appear as orders add traveller details.",
    colName: "Name",
    colOrder: "Order",
    colNationality: "Nationality",
    colPassport: "Passport",
    colDietary: "Dietary",
    colRoom: "Room",
    leadBadge: "lead",
    ordersTitle: "Orders",
    paxShort: "{{count}} pax",
    noOrders: "No orders.",
    summaryTitle: "Summary",
    rowBookedCapacity: "Booked / capacity",
    rowOrders: "Orders",
    rowPayments: "Payments",
    rowServices: "Services",
    rowCustomizations: "Customizations",
    liveOrders_one: "{{count}} live",
    liveOrders_few: "{{count}} live",
    liveOrders_other: "{{count}} live",
    cancelledOrders_one: "{{count}} cancelled",
    cancelledOrders_few: "{{count}} cancelled",
    cancelledOrders_other: "{{count}} cancelled",
    paymentsValue: "{{paid}} paid · {{deposit}} deposit · {{unpaid}} unpaid",
    overduePayments_one: "{{count}} order past a payment deadline",
    overduePayments_few: "{{count}} orders past a payment deadline",
    overduePayments_other: "{{count}} orders past a payment deadline",
    servicesValue: "{{ready}} ready · {{pending}} pending",
    servicesToConfirm_one: "{{count}} service still to confirm/book",
    servicesToConfirm_few: "{{count}} services still to confirm/book",
    servicesToConfirm_other: "{{count}} services still to confirm/book",
    customizationsValue_one: "{{count}} order",
    customizationsValue_few: "{{count}} orders",
    customizationsValue_other: "{{count}} orders",
    flightBlocksTitle: "Flight blocks",
    soldRatio: "{{used}}/{{total}} sold",
    noDeadline: "no deadline set",
    atRisk: "−{{amount}} {{currency}} at risk",
    breakEvenTitle: "Break-even",
    rowRevenue: "Revenue",
    rowCost: "Cost",
    rowMargin: "Margin",
    rowFixedCost: "Fixed cost / departure",
    rowAvgRevenue: "Avg revenue / pax",
    rowVariableCost: "Variable cost / pax",
    rowContribution: "Contribution / pax",
    rowBreakEvenPax: "Break-even pax",
    breakEvenValue: "{{value}} (have {{have}})",
    departureCard: "Departure",
    fieldCapacity: "Capacity",
    fieldWaitlist: "Waitlist",
    fieldCode: "Code",
    fieldMinPax: "Min pax (go/no-go)",
    fieldLifecycle: "Lifecycle",
    occupancyDerived: "Occupancy (derived)",
    fieldGarant: "Garant (departure owner)",
    inheritGarant: "— inherit: {{name}} (destination) —",
    fieldLeadGuide: "Lead guide (confirmed)",
    fieldCoGuide: "Co-guide (confirmed)",
    fieldRoomingNotes: "Rooming notes",
    roomingPlaceholder: "Room 1: Smith ×2 (double); Room 2: Nguyen (single)…",
    fieldGuideMessage: "Guide message (shown in portal once the guide is confirmed)",
    guideMessagePlaceholder:
      "Hi everyone, I'm your guide for this trip — can't wait to show you around…",
    fieldMeetingPoint: "Meeting point",
    inheritsPlaceholder: "Inherits: {{value}}",
    meetingPointExample: "e.g. Sheraton Hanoi lobby",
    fieldTime: "Time",
    fieldMeetingNote: "Meeting note (departure-specific instructions)",
    meetingNotePlaceholder: "Look for the guide holding a Go2 sign. Bring your passport…",
    fieldInfoMeeting: "Info meeting",
    fieldMeetingLink: "Meeting link (Google Meet)",
    infoMeetHeld: "Info meeting held {{date}}",
    markInfoMeetHeld: "Mark info meeting as held",
    savedCheck: "Saved ✓",
    saveDeparture: "Save departure",
    broadcastTitle: "Message travellers",
    composeMessage: "Compose message",
    draftTopicPlaceholder:
      "Topic to draft from (e.g. meeting point moved to the hotel lobby at 8am)",
    draftWithAiTitle: "Draft subject + body with AI",
    draftWithAi: "Draft with AI",
    subjectPlaceholder: "Subject",
    bodyPlaceholder: "Your message to every confirmed traveller on this departure…",
    sentTo: "Sent to {{sent}}/{{recipients}} travellers.",
  },
  photos: {
    title: "Trip photos",
    photoAlt: "Trip photo",
    processing: "Processing…",
    restore: "Restore",
    hide: "Hide",
  },
  guideLink: {
    title: "Guide app",
    subtitle:
      "An offline-first link to the manifest, check-in, incidents and expenses. Shown once.",
    regenerate: "Regenerate guide link",
    create: "Create guide link",
    copyLink: "Copy link",
    openLink: "Open link",
  },
  fulfillment: {
    title: "Fulfillment",
    empty: "No live orders on this departure yet.",
    colOrder: "Order",
    colPax: "Pax",
    colRoom: "Room",
    customizedTitle: "Has a customization",
    customBadge: "custom",
    customBadgeTitle: "This order has an addon/custom line",
    cols: {
      deposit: "Deposit",
      balance: "Balance",
      passport: "Passport",
      insurance: "Insurance",
      visa: "Visa",
      contract: "Contract",
    },
    stateNotRelevant: "{{label}}: not yet relevant",
    stateDone: "done",
    stateWarn: "needs attention",
    stateTodo: "to do",
    warnDeposit_one: "{{count}} deposit pending",
    warnDeposit_few: "{{count}} deposits pending",
    warnDeposit_other: "{{count}} deposits pending",
    warnBalance_one: "{{count}} balance pending",
    warnBalance_few: "{{count}} balances pending",
    warnBalance_other: "{{count}} balances pending",
    warnPassport_one: "{{count}} with missing passports",
    warnPassport_few: "{{count}} with missing passports",
    warnPassport_other: "{{count}} with missing passports",
    warnPassportExpiring_one: "{{count}} passport expiring soon",
    warnPassportExpiring_few: "{{count}} passports expiring soon",
    warnPassportExpiring_other: "{{count}} passports expiring soon",
    warnInsurance_one: "{{count}} without insurance",
    warnInsurance_few: "{{count}} without insurance",
    warnInsurance_other: "{{count}} without insurance",
    warnVisa_one: "{{count}} visa pending",
    warnVisa_few: "{{count}} visas pending",
    warnVisa_other: "{{count}} visas pending",
    warnContract_one: "{{count}} contract unsigned",
    warnContract_few: "{{count}} contracts unsigned",
    warnContract_other: "{{count}} contracts unsigned",
  },
  entryTasks: {
    title: "Entry documents",
    subtitle:
      "Arrival cards & visas filed for the travellers. The shield shows the client's filing consent from the portal; dots = passport / flight / hotel / contact readiness.",
    windowUnknown: "Window unknown — set it in Country KB",
    windowOpenSince: "Window OPEN since {{date}}",
    windowOpens: "Window opens {{date}}",
    readyToFile: "Ready to file",
    missingList: "Missing: {{list}}",
    dotPassport: "Passport",
    dotFlight: "Flight",
    dotHotel: "Hotel",
    dotContact: "Contact",
    dotOk: "OK",
    dotMissing: "missing",
    sheetLoadFailed: "Failed to load the filing sheet",
    groupOf: "group of {{max}}",
    autoOn: "auto on",
    autoOff: "auto off",
    autoOnTitle:
      "Auto-filing on — the hourly cron files open tasks inside the window (consent + global switch required)",
    autoOffTitle:
      "Auto-filing off for this country — enable it in Country KB; dry runs work regardless",
    copySheet: "Copy filing sheet",
    openPortalTitle: "Open the official portal",
    portal: "Portal",
    colTraveller: "Traveller",
    colOrder: "Order",
    colReady: "Ready",
    colArrival: "Arrival",
    colStatus: "Status",
    colReference: "Reference",
    colAuto: "Auto",
    colQrFile: "QR / file",
    consentGiven: "Filing consent given",
    consentMissing: "No filing consent yet",
    statusOpen: "open",
    statusFiled: "filed",
    statusFailed: "failed",
    statusSkipped: "skipped",
    refPlaceholder: "conf. no.",
    dryRunTitle:
      "Dry run — fills the whole portal form, stops before submit, stores a review screenshot",
    confirmFileNow:
      "File the {{country}} arrival card for {{name}} NOW? This submits to the government portal.",
    timedOutTitle:
      "Previous filing timed out — verify on the portal/QR, then use Retry (do not double-file)",
    attemptedTitle:
      "A previous attempt already ran — verify on the portal/QR, then use Retry (do not double-file)",
    consentMissingTitle: "Client consent missing (portal)",
    autoOffCountryTitle: "Auto-filing off for this country (Country KB)",
    fileNowTitle: "File now via the cloud browser",
    confirmRetry:
      "Have you verified on the government portal/QR that {{name}}'s {{country}} card is NOT already filed? This re-enables filing.",
    retryTitle: "Verified on the portal — clear the block and allow re-filing",
    queuedLabel: "Queued — refresh in a minute",
    filedAuto: "Filed automatically",
    uploadTitle: "Upload the QR / confirmation",
    openArtifact: "Open {{name}}",
    artifactFallback: "artifact",
  },
};
